import { Badge, Card, CardBody, CardHeader } from "@odingard/design-system";
import { useAuth } from "../../lib/auth";

export function OrganizationPage() {
  const { activeOrg } = useAuth();
  if (!activeOrg) return null;
  return (
    <>
      <div className="page-head">
        <div>
          <h1>Organization</h1>
          <p>Details and permissions for {activeOrg.name}.</p>
        </div>
      </div>
      <div className="two-col">
        <Card>
          <CardHeader title="Details" />
          <CardBody>
            <dl className="kv">
              <dt>Name</dt>
              <dd>{activeOrg.name}</dd>
              <dt>Slug</dt>
              <dd>
                <code>{activeOrg.slug}</code>
              </dd>
              <dt>Organization ID</dt>
              <dd>
                <code>{activeOrg.id}</code>
              </dd>
              <dt>Your role</dt>
              <dd>
                <Badge tone="info">{activeOrg.role}</Badge>
              </dd>
            </dl>
          </CardBody>
        </Card>
        <Card>
          <CardHeader title="Your permissions" />
          <CardBody>
            <div className="ods-stack">
              {activeOrg.permissions.length === 0 ? (
                <span style={{ color: "var(--ods-color-muted)" }}>No elevated permissions.</span>
              ) : (
                activeOrg.permissions.map((p) => (
                  <code key={p} style={{ fontSize: "var(--ods-text-sm)" }}>
                    {p}
                  </code>
                ))
              )}
            </div>
          </CardBody>
        </Card>
      </div>
    </>
  );
}
